import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcRestService} from 'exc-rest';
import {resolveProjectModule} from '@angular-devkit/build-angular/src/angular-cli-files/utilities/require-project-module';

@Component({
  selector: 'app-modal-new-location',
  templateUrl: './modal-new-location.component.html',
  styles: []
})
export class ModalNewLocationComponent extends ExcTranslation implements OnInit {

  location: {
    LocationName: string,
    LocationStreet: string,
    LocationZip: string,
    LocationCountry: string,
    LocationCity: string,
    LocationIsBusiness: boolean,
    LocationIsApproved: boolean,
    LocationID: number
  } = {
    LocationIsBusiness: true,
    LocationIsApproved: false,
    LocationZip: null,
    LocationCity: null,
    LocationStreet: null,
    LocationCountry: null,
    LocationID: null,
    LocationName: null
  }
  dealerID;
  isEdit = false;
  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef,  public excRest: ExcRestService) {
    super();
    const _self = this;
  }

  ngOnInit() {
    const _self = this;
    if (_self.overlayConfig.data.Data !== null) {
      Object.assign(_self.location, _self.overlayConfig.data.Data);
      if (_self.overlayConfig.data.Data.IsEdit !== undefined && _self.overlayConfig.data.Data.IsEdit !== null)  {
        _self.isEdit = _self.overlayConfig.data.Data.IsEdit;
      }
    }

    _self.dealerID = _self.overlayConfig.data.Dealer.DealerID;
  }
  addLocation() {
    const _self = this;
      _self.overlayRef.close({proceed: true, location: _self.location});
  }
}
